import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type StartETMImportByURLResponse = {
   jobId: string;
};

export async function startExternalTrainingModuleImportByURL(
   importId: number,
   url: string,
   common: CommonRequestOptions = {}
): Promise<StartETMImportByURLResponse> {
   return makeRequest('post', `/external-training-modules/imports/${importId}/start/byUrl`, {
      ...common,
      body: {
         url,
      },
   });
}
